import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionListPane from 'flarum/forum/components/DiscussionListPane';
import Footer from 'flarum/forum/components/Footer';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import UserPage from 'flarum/forum/components/UserPage';
import TagsPage from 'ext:flarum/tags/forum/components/TagsPage';
import BoardIndex from './components/BoardIndex';
import BoardStats from './components/BoardStats';
import SupportBlock from './components/SupportBlock';
import ForumHead from './components/ForumHead';
import LoginRequired from './components/LoginRequired';
import topicRow from './components/TopicRow';
import extendPosts from './extendPosts';
import extendSearchBox from './searchBox';
import { readOnly } from './utils';
app.initializers.add('runeaudio-theme', () => {
  // riquadro FORUM: menu e briciole di pane, ridisegnati a ogni cambio di pagina
  extend(app, 'mount', function () {
    const head = document.getElementById('runeaudio-forum-head');
    if (head) m.mount(head, ForumHead);
  });

  // menu del sito su telefono (il bottone sta nell'HTML statico del layout)
  extend(app, 'mount', function () {
    const toggle = document.querySelector('.SiteHeader-toggle');
    toggle?.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      document.querySelector('.SiteHeader').classList.toggle('is-open', open);
    });
  });

  // ---------------------------------------------------------------- indice: tabelle per categoria
  override(TagsPage.prototype, 'view', function () {
    return m("div", {
      className: "TagsPage RuneaudioPage"
    }, m("div", {
      className: "container"
    }, this.loading ? m(LoadingIndicator, null) : [m(BoardIndex, {
      tags: this.tags
    }), m(BoardStats, null)]));
  });

  // ---------------------------------------------------------------- lista topic: titolo, azioni, tabella
  override(IndexPage.prototype, 'view', function () {
    return m("div", {
      className: "IndexPage RuneaudioPage"
    }, m("div", {
      className: "container"
    }, this.hero(), this.contentItems().toArray()));
  });
  override(IndexPage.prototype, 'hero', function () {
    const tag = app.currentTag?.();
    const count = tag ? tag.discussionCount() : null;
    return m("div", {
      className: "TopicListHead"
    }, m("h2", null, tag ? tag.name() : 'Active topics'), m("div", {
      className: "TopicActions"
    }, readOnly() && !app.forum.attribute('canStartDiscussion') ? m("span", null) : m(Button, {
      className: "Button PhpbbButton PhpbbButton--new",
      onclick: () => IndexSidebar.prototype.newDiscussionAction().catch(() => {})
    }, "new ", m("strong", null, "topic")), count !== null && m("div", {
      className: "TopicActions-count"
    }, count, " topics")));
  });

  // la barra di Flarum (ordinamento, aggiorna) non c'era in phpBB
  extend(IndexPage.prototype, 'contentItems', function (items) {
    items.has('toolbar') && items.remove('toolbar');
  });
  override(DiscussionList.prototype, 'view', function (original) {
    const state = this.attrs.state;
    if (state.isEmpty()) return original();
    const params = state.getParams();
    const loading = state.isInitialLoading() || state.isLoadingNext();
    return m("div", {
      className: "DiscussionList"
    }, m("div", {
      className: "ForumTable"
    }, m("ul", {
      className: "ForumTable-header"
    }, m("li", null, m("dl", null, m("dt", null, "Topics"), m("dd", {
      className: "ForumTable-count"
    }, "Replies"), m("dd", {
      className: "ForumTable-count"
    }, "Views"), m("dd", {
      className: "ForumTable-last"
    }, "Last post")))), m("ul", {
      "aria-busy": loading,
      className: "ForumTable-rows DiscussionList-discussions"
    }, state.getPages().map(pg => pg.items.map(discussion => m("li", {
      key: discussion.id(),
      "data-id": discussion.id(),
      className: "ForumTable-row"
    }, m(DiscussionListItem, {
      discussion: discussion,
      params: params
    })))))), m("div", {
      className: "DiscussionList-loadMore"
    }, loading ? m(LoadingIndicator, null) : state.hasNext() && m(Button, {
      className: "Button PhpbbButton",
      onclick: state.loadNext.bind(state)
    }, app.translator.trans('core.forum.discussion_list.load_more_button'))));
  });
  override(DiscussionListItem.prototype, 'contentView', function () {
    return m("div", {
      className: "DiscussionListItem-content"
    }, topicRow(this.attrs.discussion));
  });

  // ---------------------------------------------------------------- topic: titolo e azioni, niente barra laterale
  override(DiscussionPage.prototype, 'hero', function () {
    const discussion = this.discussion;
    if (!discussion) return null;
    return m("div", {
      className: "container TopicListHead"
    }, m("h2", null, discussion.title()), m("div", {
      className: "TopicActions"
    }, readOnly() && !discussion.canReply() ? m("span", null) : discussion.isLocked?.() ? m("span", {
      className: "PhpbbButton PhpbbButton--locked"
    }, "topic ", m("strong", null, "locked")) : m(Button, {
      className: "Button PhpbbButton PhpbbButton--reply",
      onclick: () => DiscussionControls.replyAction.call(discussion, true, false).catch(() => {})
    }, "post ", m("strong", null, "reply")), m("div", {
      className: "TopicActions-count"
    }, (discussion.replyCount() ?? 0) + 1, " posts")));
  });
  override(DiscussionPage.prototype, 'sidebar', () => null);

  // RUNE-83: niente pannello laterale con la lista dei topic. Flarum lo fa entrare dal bordo sinistro
  // (mousemove a meno di 10px, registrato in oncreate) su schermi larghi; phpBB non lo aveva.
  // Pane disattivato anche per i browser con "panePinned" salvato, che sposterebbe il layout.
  override(DiscussionListPane.prototype, 'view', () => null);
  override(DiscussionListPane.prototype, 'oncreate', () => {});
  override(DiscussionListPane.prototype, 'onremove', () => {});
  extend(DiscussionPage.prototype, 'oninit', () => app.pane?.disable());

  // ---------------------------------------------------------------- profili: solo per chi è entrato, come in phpBB
  // (l'API non li dà agli ospiti: niente richiesta, e la promessa resta in sospeso per le sottoclassi che la seguono)
  override(UserPage.prototype, 'loadUser', function (original, username) {
    return app.session.user ? original(username) : new Promise(() => {});
  });
  override(UserPage.prototype, 'view', function (original) {
    return app.session.user ? original() : m(LoginRequired, null);
  });

  // ---------------------------------------------------------------- piè di pagina del forum (sopra il footer del sito)
  override(Footer.prototype, 'view', () => m("div", {
    className: "container ForumFoot"
  }, m("div", {
    className: "ForumFoot-bar"
  }, m("a", {
    href: app.route('tags')
  }, "Board index")), m("div", {
    className: "ForumFoot-copyright"
  }, "Powered by", ' ', m("a", {
    href: "https://flarum.org",
    rel: "noopener"
  }, "Flarum"))));
  extendPosts();
  extendSearchBox();
});